module.exports = __webpack_public_path__ + "static/innomedia-96e709b3d84b1aad059d6a4e5071c1c6.jpg";